// extracted by mini-css-extract-plugin
export var box = "DirectionCard-module--box--2630b";
export var box_md = "DirectionCard-module--box_md--211e8";
export var box_xmd = "DirectionCard-module--box_xmd--a8524";
export var box_flex = "DirectionCard-module--box_flex--7dff4";
export var box_lg = "DirectionCard-module--box_lg--c2ee8";
export var box_sm = "DirectionCard-module--box_sm--3cced";
export var box_outer = "DirectionCard-module--box_outer--59a7d";
export var box_whiteBg = "DirectionCard-module--box_white-bg--46190";
export var box_noMarginBottom = "DirectionCard-module--box_no-margin-bottom--99d0d";
export var box_noPadding = "DirectionCard-module--box_no-padding--5ad38";
export var box_outerGray = "DirectionCard-module--box_outer-gray--6d38d";
export var box_dark = "DirectionCard-module--box_dark--d4183";
export var box_zIndex = "DirectionCard-module--box_z-index--66d94";
export var box_zIndex6 = "DirectionCard-module--box_z-index-6--a27b0";
export var box_eventsWithLine = "DirectionCard-module--box_events-with-line--011ee";
export var box_featuresAo = "DirectionCard-module--box_features-ao--ada8d";
export var box_verticalPaddings = "DirectionCard-module--box_vertical-paddings--91c27";
export var clearP = "DirectionCard-module--clearP--fe951";
export var clearP_vc = "DirectionCard-module--clearP_vc--adff5";
export var card = "DirectionCard-module--card--f76b7";
export var title = "DirectionCard-module--title--de5ed";
export var list = "DirectionCard-module--list--3e9ba";
export var button = "DirectionCard-module--button--23a00";
export var fadeInAnimation = "DirectionCard-module--fadeInAnimation--62d2a";
export var placeHolderShimmer = "DirectionCard-module--placeHolderShimmer--171fe";